import {Icon, Modal, Spin} from 'antd';
import moment from 'moment';
import React from 'react';
import {Query} from 'react-apollo';
import {GET_ORDERS} from '../../../../graphql';
import {getIntoObject} from '../../../../helpers';
import {Order} from '../../../../interfaces';

interface Properties {
  isOpen: boolean;
  closeModal: () => void;
  regionId: string;
  filter: string;
}

class ExportModal extends React.PureComponent<Properties> {
  export(data: Array<Order>) {
    let csvContent = 'data:text/csv;charset=utf-8,';
    csvContent +=
      `Date,Time,Email,Phone,Country,Club,` +
      `Membership Title,Membership Code,Starterpack Title,Starterpack Code,Promo Code,step,` +
      `Current month,Deposit,Joining Pack,` +
      `Total,Monthly Fee,Error Detail \r\n`;

    data
      .forEach(function(x: any) {
        const {order,errors} = x;
        const date: Date = Number(x.createdAt) ? new Date(Number(x.createdAt)) : new Date(x.createdAt);

        let row =
          `${moment(date).format('YYYY-MM-DD')},${moment(date).format('HH:mm')},` +
          `${getIntoObject(order, ['person', 'email'], '')},` +
          `${getIntoObject(order, ['person', 'mobile'], '')},` +
          `${getIntoObject(order, ['person', 'country'], '')},` +
          `${getIntoObject(order, ['currentClub', 'name'], '')},` +
          `${getIntoObject(order, ['currentMembership', 'title'], '')},` +
          `${getIntoObject(order, ['currentMembership', 'externalId'], '')},` +
          `${getIntoObject(order, ['currentStarterpack', 'title'], '')},` +
          `${getIntoObject(order, ['currentStarterpack', 'externalId'], '')},` +
          `${getIntoObject(order, ['contract', 'promoCode'], '')},` +
          `${getIntoObject(order, ['salesProcessQueryParamsObject', 'step'], '')},` +
          `${getIntoObject(order, ['contract', 'price', 'proRataPrice'], '')},` +
          `${getIntoObject(order, ['contract', 'price', 'deposit'], '')},` +
          `${getIntoObject(order, ['contract', 'price', 'joiningFeePrice'], '')},` +
          `${getIntoObject(order, ['contract', 'price', 'totalAmount'], '')},` +
          `${getIntoObject(order, ['contract', 'price', 'normalPeriodPrice'], '')},` +
          `${getIntoObject(errors, ['unit4','msg'], '')},`;

        csvContent += `${row}\r\n`;
      });

    const encodedUri = encodeURI(csvContent);
    const link = document.createElement('a');
    link.setAttribute('href', encodedUri);
    link.setAttribute('download', `sales-export-${moment().format('YYYY-MM-DD')},${moment().format('HHmm')}.csv`);
    document.body.appendChild(link); // Required for FF
    link.click();
    this.props.closeModal();
  }

  render() {
    const {regionId, closeModal, isOpen, filter} = this.props;
    return (
      <Modal title="Export CSV Modal" visible={isOpen} onCancel={closeModal} destroyOnClose okButtonProps={{style: {display: 'none'}}}>
        <Query query={GET_ORDERS} variables={{regionId, filter}}>
          {({loading, error, data: {order}}: any) => {
            if (loading) {
              const icon = <Icon type="loading" style={{fontSize: 24, marginRight: 10}} spin />;
              return (
                <div>
                  <Spin indicator={icon} />
                  Preparing Data for CSV...
                </div>
              );
            }
            if (error) {
              return `Error! ${error.message}`;
            }

            this.export(order.order);
            return <div>Data are ready for export</div>;
          }}
        </Query>
      </Modal>
    );
  }
}

export default ExportModal;



// WEBPACK FOOTER //
// ./src/pages/SubmissionCrmErrorsPage/components/ListOrders/components/ListOrders/ExportModal.tsx